import React from 'react';

const DialerSkeleton = () => (
  <div className="w-full h-full bg-white flex items-center justify-center">
    <div className="flex flex-col items-center gap-3">
      <div className="w-8 h-8 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
      <p className="text-sm text-gray-400">Loading dialer...</p>
    </div>
  </div>
);

export default DialerSkeleton;
